export const randomId = () => {
    return Math.random().toString(36).substr(2, 10);
};
export enum Regex {
    EMAIL = '^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,20}$',
    PASSWORD = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{6,32})',
    // PASSWORD = '^(?=.*[a-z])(?=.*)(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{6,32})',
}

export const kycStatus = {
    NEW: 'new',
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected',
};
export const BREAKPOINT_MOBILE = 600;
